import type { Rect, UiRects } from "../../game/input";
import type { RenderModel } from "../renderModel";
import { GAME_FONT, type PhoneMetrics } from "../renderConstants";

// ── Dependency interface ────────────────────────────────────────────

// No external deps needed — this screen is self-contained.
export interface PhoneEditUsernameDeps {
  // intentionally empty — no this.xxx callbacks used
}

// ── Extracted screen function ───────────────────────────────────────

export function drawPhoneEditUsernameScreen(
  _deps: PhoneEditUsernameDeps,
  ctx: CanvasRenderingContext2D,
  model: RenderModel,
  uiRects: UiRects,
  scrX: number, scrY: number, scrW: number, _scrH: number,
  contentX: number, contentW: number,
  metrics: PhoneMetrics,
): void {
  const desktop = metrics.desktop;
  let curY = scrY + metrics.topPad;

  // Back button (same as add-friend)
  const backW = desktop ? 50 : 40;
  const backH = metrics.inlineButtonH;
  const backRect: Rect = { x: contentX, y: curY, w: backW, h: backH };
  uiRects.phoneEditUsernameBack = backRect;
  ctx.fillStyle = "#162030";
  ctx.fillRect(backRect.x, backRect.y, backRect.w, backRect.h);
  ctx.strokeStyle = "#64d8ff";
  ctx.lineWidth = 1;
  ctx.strokeRect(backRect.x, backRect.y, backRect.w, backRect.h);
  ctx.fillStyle = "#64d8ff";
  ctx.font = `bold ${metrics.helperFontPx}px ${GAME_FONT}`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("\u2190 BACK", backRect.x + backRect.w / 2, backRect.y + backRect.h / 2);
  curY += backH + 12;

  // Title
  ctx.fillStyle = "#ff6b9d";
  ctx.font = `bold ${metrics.titleFontPx}px ${GAME_FONT}`;
  ctx.textAlign = "center";
  ctx.textBaseline = "top";
  ctx.fillText("EDIT USERNAME", scrX + scrW / 2, curY);
  curY += metrics.titleGap;

  // Helper text
  ctx.fillStyle = "#8eb6d9";
  ctx.font = `${metrics.helperFontPx}px ${GAME_FONT}`;
  ctx.fillText("3-16 CHARS, LETTERS, NUMBERS & _", scrX + scrW / 2, curY);
  curY += metrics.helperFontPx + 8;

  // Input (HTML input overlaid here)
  const inputH = desktop ? 20 : 18;
  const inputRect: Rect = { x: contentX, y: curY, w: contentW, h: inputH };
  uiRects.usernameInput = inputRect;
  ctx.fillStyle = "rgba(15,22,40,0.95)";
  ctx.fillRect(inputRect.x, inputRect.y, inputRect.w, inputRect.h);
  ctx.strokeStyle = "#5c8cd4";
  ctx.lineWidth = 1;
  ctx.strokeRect(inputRect.x, inputRect.y, inputRect.w, inputRect.h);
  curY += inputH + 6;

  // Save button (CTA style, same as add-friend send)
  const ctaH = metrics.ctaH;
  const saveRect: Rect = { x: contentX, y: curY, w: contentW, h: ctaH };
  uiRects.usernameClaim = saveRect;
  ctx.fillStyle = "#0a2a10";
  ctx.fillRect(saveRect.x, saveRect.y, saveRect.w, saveRect.h);
  ctx.strokeStyle = "#4dff88";
  ctx.lineWidth = 1;
  ctx.strokeRect(saveRect.x, saveRect.y, saveRect.w, saveRect.h);
  ctx.fillStyle = "#4dff88";
  ctx.font = `bold ${metrics.actionFontPx}px ${GAME_FONT}`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("SAVE", saveRect.x + saveRect.w / 2, saveRect.y + saveRect.h / 2);
  curY += ctaH + 8;

  // Error/success message
  if (model.versusError) {
    ctx.fillStyle = "#ff6b6b";
    ctx.font = `bold ${metrics.helperFontPx}px ${GAME_FONT}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText(model.versusError, scrX + scrW / 2, curY);
  }
}
